export enum CommonInternalStates {
  Redirecting = 'redirecting',
}
